import {IWineShop} from 'modules/wineshops-list/models';
import {createContext, Dispatch, SetStateAction} from 'react';

interface IIndividualTastingContext {
    isSelectWineShopOpen?: boolean;
    selectedWineShop?: IWineShop;
    setIsSelectWineShopOpen?: Dispatch<boolean>;
    setSelectedWineShop?: Dispatch<SetStateAction<IWineShop | undefined>>;
}

export const IndividualTastingContext = createContext<IIndividualTastingContext>({});
